var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurveyTools(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 96,
    viewBox: "0 0 120 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.934 45.6001L107.863 45.6346L108 75.6001L103.071 75.5652L85.2442 65.3077L85.2 55.6067L102.934 45.6001Z",
    fill: "#8372FF",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102 46.8V74.4",
    stroke: "#1B1B1B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.941 38.5869L25.9277 38.3999C24.8598 38.3967 23.9968 39.2559 24 40.319L24.1195 79.4821C24.1228 80.5452 24.9911 81.4096 26.059 81.4129L88.0723 81.5999C89.1402 81.6031 90.0032 80.7439 90 79.6808L89.8805 40.5177C89.8772 39.4546 89.0089 38.5902 87.941 38.5869Z",
    fill: "#E4E1FF",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6716 38.3997C75.1696 38.4368 80.4207 33.121 80.3999 26.5268C80.3792 19.9326 75.0945 14.5565 68.5965 14.5194L47.7284 14.4001C41.2304 14.363 35.9793 19.6788 36.0001 26.273C36.0208 32.8672 41.3055 38.2433 47.8035 38.2804L68.6716 38.3997Z",
    fill: "#8372FF",
    stroke: "#1B1B1B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.081 33.1607C66.6617 34.5252 62.8684 32.6044 61.6086 28.8705C60.3488 25.1366 62.0995 21.0036 65.5189 19.6392C68.9382 18.2747 72.7315 20.1955 73.9913 23.9294C75.2511 27.6633 73.5004 31.7963 70.081 33.1607Z",
    fill: "white",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4885 33.1607C46.7582 34.5252 42.6202 32.6044 41.2458 28.8705C39.8715 25.1366 41.7813 21.0036 45.5116 19.6392C49.2418 18.2747 53.3799 20.1955 54.7543 23.9294C56.1286 27.6633 54.2187 31.7963 50.4885 33.1607Z",
    fill: "white",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1309 49.8899L28.9762 49.9533L55.9826 49.5088C58.9155 49.5278 61.1871 51.7867 61.1999 54.562C61.2127 57.3374 58.9622 59.5742 56.0293 59.5552L29.0224 59.9999L13.2719 59.8985L13.2 44.3999C15.747 44.4162 17.973 46.6341 19.1309 49.8899Z",
    fill: "#FFBB00",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyTools);
export default __webpack_public_path__ + "static/media/survey-tools.481c5328.svg";
export { ForwardRef as ReactComponent };